import React from 'react';
import { Dialog } from 'primereact/dialog';
import { LossOfExclusivityInfoCardData } from 'Interfaces/ProductWikiInterfaces/landingPage.types';
import { getTagText } from '../../../utils/tagUtils';
import './LossOfExclusivityDetailModal.styles.scss';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';

interface LossOfExclusivityDetailModalProps {
  visible: boolean;
  onHide: () => void;
  data: LossOfExclusivityInfoCardData | null;
}

const LossOfExclusivityDetailModal: React.FC<LossOfExclusivityDetailModalProps> = ({
  visible,
  onHide,
  data,
}) => {
  // Render title with line breaks (Generic Name, Brand Name, Brand Company on separate lines)
  const renderTitle = () => {
    if (!data?.title) return null;
    const lines = data.title.split('\n');
    return lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));
  };

  // Render description with line breaks and bold labels
  const renderDescription = () => {
    if (!data?.description) return null;
    const lines = data.description.split('\n');
    const boldLabels = ['First Filers:', 'Other Filers:', 'Notes:'];

    return lines.map((line, index) => {
      // Check if line starts with any bold label
      const matchedLabel = boldLabels.find(label => line.startsWith(label));

      if (matchedLabel) {
        const restOfLine = line.slice(matchedLabel.length);
        return (
          <React.Fragment key={index}>
            <strong>{matchedLabel}</strong>
            {restOfLine}
            {index < lines.length - 1 && <br />}
          </React.Fragment>
        );
      }

      return (
        <React.Fragment key={index}>
          {line}
          {index < lines.length - 1 && <br />}
        </React.Fragment>
      );
    });
  };

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={null}
      className="loe-detail-modal"
      modal
      dismissableMask
      draggable={false}
      resizable={false}
      style={{ width: '90vw', maxWidth: '800px' }}
    >
      {data ? (
        <div className="loe-detail-modal-content">
          {/* Header with Title and Date */}
          <div className="loe-detail-modal-header">
            <h2 className="loe-detail-modal-title">{renderTitle()}</h2>
            <div className="loe-detail-modal-date">{data.date}</div>
          </div>

          {/* Scrollable Description */}
          <div className="loe-detail-modal-description">{renderDescription()}</div>

          {/* Tags at Bottom */}
          <div className="loe-detail-modal-tags">
            {data.tags &&
              data.tags.map((tag, index) => (
                <span key={index} className={`loe-detail-modal-tag ${tag.type}`}>
                  {getTagText(tag, false)}
                </span>
              ))}
          </div>
        </div>
      ) : (
        <div className="loe-detail-modal-content">
          <div>No data available</div>
        </div>
      )}
    </Dialog>
  );
};

export default LossOfExclusivityDetailModal;
